import React, { useEffect, useState } from "react";
import {
  ButtonPrimary,
  ButtonSecondary,
  ButtonWarning,
  FormGroup,
  InputTextblock,
  Layout,
  Loader,
  SelectDropDown,
} from "../../../components";
import { FiEdit, FiPlus, FiTrash, FiXCircle } from "react-icons/fi";
import { ModalSosial } from "../../../components/organisms/Modal";
import { postDataPages } from "../../../service/sosialMediaService";
import { Toption, initialOption } from "../../../type/option";
import { TsosialMedia } from "../../../type/sosialMedia";
import { TusersSosialMedia } from "../../../type/usersSosialMedia";
import { showMessage } from "../../../utls/message";
import {
  getDataSosial,
  postData,
} from "../../../service/usersSosialMediaService";
import { MINIO } from "../../../data/data";
import { Link } from "react-router-dom";
import { Loader2 } from "../../../components/atoms/Loader";
import { getDataStore } from "../../../service/usersStoreService";
import { Tstore } from "../../../type/store";

const OfflineStore = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [myStore, setMyStore] = useState<Tstore[]>([]);

  const getMyStore = async () => {
    setIsLoading(true);
    const response = await getDataStore();
    if (response?.code === 200 && !response.error) {
      setMyStore(response.data.content || response.data || []);
    }

    setIsLoading(false);
  };

  useEffect(() => {
    getMyStore();
  }, []);

  return (
    <Layout title="Toko Offline Saya" showNavBar={true} showNavigation={false}>
      {isLoading ? (
        <div className="h-screen">
          <Loader2 />
        </div>
      ) : (
        <div className="mt-[4rem] relative min-h-[calc(100vh-90px)] w-full overflow-auto">
          {myStore.map((item: Tstore, index: number) => {
            return (
              <div
                key={index}
                className="flex flex-col gap-5 justify-between bg-white p-4 rounded-md shadow-lg my-2"
              >
                <div className="w-full flex items-center justify-between">
                  <div className="flex gap-2">
                    <span className="block p-0 m-0 font-extrabold">
                      {item.name}
                    </span>
                    |<span className="block p-0 m-0">{item.phone}</span>
                    <Link to={item.uniqueId ?? ""}>
                      <button>
                        <FiEdit className="w-4" />
                      </button>
                    </Link>
                  </div>
                  {/* <button>
										<FiXCircle className="w-6 h-6 mb-1.5 fill-red-600 text-white" />
									</button> */}
                </div>

                <p className="p-0 m-0 text-[12px] text-gray-500">
                  {item.address} <br />
                  {item.district.districtName}, {item.district.city.cityName},{" "}
                  {item.district.city.provinsi.provinsiName} - {item.postalCode}
                </p>
              </div>
            );
          })}
          <div className="fixed bottom-[2rem] left-1/2 -translate-x-1/2 max-w-[480px] w-full flex justify-end px-3 z-[888] pointer-events-none">
            <Link to="create" className="pointer-events-auto">
              <button className="p-3 rounded-full shadow-lg text-white bg-primary">
                <FiPlus />
              </button>
            </Link>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default OfflineStore;
